<template>
  <Modal class="modal-center cate-pink" @close-modal="$emit('close-modal-get-point')">
    <div slot="body" class="responsive-height">
      <!-- NOTI SHARE TWITTER -->
      <div class="block-vertical">
        <ListItem
          :list="listRecommendModal"
          titleModal="スタッフいちおし!"
          hasBackground
          mode="vertical"
          isChangeBackground
          isInModal
          keepModal
        />
      </div>

      <div class="warning-share">
         <button
           class="btn-modal-recommend"
           @click="$emit('handle-get-point')"
           v-html="'ポイントゲット'"
         />

        <button
          class="btn-modal-recommend"
          @click="$emit('close-modal-get-point')"
          v-html="'閉じる'"
        />
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapState } from 'vuex'
import Common from '@/mixins/common.mixin'

import Modal from '@/components/advertising-detail/Modal'
import ListItem from '@/components/ListItem.vue'

export default {
  name: 'ModalGetPoint',

  components: {
    Modal,
    ListItem
  },

  mixins: [Common],

  computed: {
    ...mapState('advertises', ['listRecommendModal'])
  },

  created () {
    this.$store.dispatch('advertises/getListRecommendModal')
  }
}
</script>

<style lang="scss" scoped></style>
